import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  id: number | null;
}

const initialState: UserState = {
  id: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    /**
     * @description
     * Redux action to set the currently selected app type.
     * @param action `string` - The user email to set.
     * @example
     * ```ts
     * dispatch(userSliceActions.setUserId(1));
     * ```
     */
    setUserId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
    clearUserId: (state) => {
      state.id = null;
    },
  },
});

// Private actions are used internally by redux-state package only.
// This is to avoid having these values set in unintentional locations.
export const userSlicePrivateActions = {};

// Public actions can be used by any consumer of the redux-state package.
export const userSlicePublicActions = {
  setUserId: userSlice.actions.setUserId,
  clearUserId: userSlice.actions.clearUserId,
};

export default userSlice;
